import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="live-assistant"
export default class extends Controller {
  connect() {
    console.log("connected live assistant")
    this.sendDom()
  }

  sendDom() {
    console.log('sendDom')
    const dom = document.documentElement.outerHTML

    fetch('/api/v1/live_assistant/dom_update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        dom: dom, 
        screen_width: window.screen.width,
        screen_height: window.screen.height,
        url: window.location.href
      })
    })
  }
}
